import React, {useEffect, useState} from 'react';
import {aHourMillisecond, SHORT_TIME_FORMAT} from "../../../../../util/varibles/constants";
import {datetime} from "../../../../../util/library/datetime";
import styles from './style.module.scss';

interface IProps {
    startPoint: number
}

const CurrentTimeLine: React.FC<IProps> = ({startPoint}) => {
    const [currentTime, setCurrentTime] = useState<number>(Date.now());
    useEffect(() => {
        const interval = setInterval(() => setCurrentTime(Date.now()), 10000)
        return () => {
            clearInterval(interval)
        };
    }, []);

    return <div className='sticky z-[6] h-full w-0 left-[110px]'>
        <div className={styles.currentTimeLine} style={{top: `${(currentTime - startPoint) / aHourMillisecond * 5}px`}}>
            <span>{datetime(currentTime).format(SHORT_TIME_FORMAT)}</span>
        </div>
    </div>;
};

export default CurrentTimeLine;

